import { IMGIX_ENV, IMGIX_URL } from '../src/env';

export const getImgxSrc = (path: string, isDevDependence = false) => {
  const env = isDevDependence ? 'global' : IMGIX_ENV;
  return `${IMGIX_URL}/${env}/${path}`;
};

export const getArticleImgSrc = (id?: number, picture?: string) => {
  if (!picture) return getImgxSrc(`/articles/article_default.jpg`);
  return getImgxSrc(`/articles/${id}/${picture}`);
};
